import React from 'react';

import { useAccountState, useAccountActions } from './AccountContext';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import CloseAccountForm from './CloseAccountForm';

const AccountCloseModal = () => {
  const state = useAccountState();
  const { closeAccountCloseModal } = useAccountActions();

  return (
    <StandardModal
      isOpen={state?.accountCloseModalIsOpen}
      contentLabel="Close Account"
      onRequestClose={() => {
        closeAccountCloseModal();
      }}
    >
      <CloseAccountForm />
    </StandardModal>
  );
};

export default AccountCloseModal;